import { render, staticRenderFns } from "./DialogComponent.vue?vue&type=template&id=fdfe3884&scoped=true"
import script from "./DialogComponent.js?vue&type=script&lang=js&external"
export * from "./DialogComponent.js?vue&type=script&lang=js&external"
import style0 from "./DialogComponent.vue?vue&type=style&index=0&id=fdfe3884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfe3884",
  null
  
)

export default component.exports